import { render, staticRenderFns } from "./UserGroupPermissions.vue?vue&type=template&id=ff823726&scoped=true&"
import script from "./UserGroupPermissions.vue?vue&type=script&lang=js&"
export * from "./UserGroupPermissions.vue?vue&type=script&lang=js&"
import style0 from "./UserGroupPermissions.vue?vue&type=style&index=0&id=ff823726&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff823726",
  null
  
)

export default component.exports